import React from 'react'

import {
    DeleteButton,
    InlineActions,
    LessonCard,
    LessonMain,
    LessonMeta,
    LessonNumber,
    LessonSubject,
    WindowBadge,
} from '../../../components/scharedStyles/style'
import {
    formatTeacherFromItem,
    getClassTypeName,
    getLesson,
    getRoomName,
    getSubjectName,
    isWindowLesson,
} from '../../schedule/utils/lessonHelpers'
import { getClassId, getGroupsDisplayName } from '../utils/lessonHelpers'
import { useAppSelector } from '../../../store/hooks'
import { referencesSelector } from '../../../store/slices/references'

const EditScheduleLessonCard = ({
    item,
    index,
    isEditing,
    onEdit,
    onDelete,
}) => {
    const groups = useAppSelector(referencesSelector.groups)
    const lesson = getLesson(item)
    const classId = getClassId(item, lesson)
    const isWindow = isWindowLesson(item, lesson)

    if (isEditing) {
        return null
    }

    const groupsDisplayName = getGroupsDisplayName(item, lesson, groups)

    return (
        <LessonCard
            $isWindow={isWindow}
            onClick={() => onEdit(item)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    onEdit(item)
                }
            }}
        >
            <LessonNumber $isWindow={isWindow}>
                {lesson?.bell_id || item?.bell_id || index + 1}
            </LessonNumber>

            <LessonMain>
                <LessonSubject>
                    {isWindow ? 'Окно' : getSubjectName(item, lesson)}
                </LessonSubject>

                <LessonMeta>
                    {isWindow ? (
                        <>
                            <WindowBadge>Свободный слот</WindowBadge>
                            <span>
                                <b>Группа:</b> {groupsDisplayName}
                            </span>
                        </>
                    ) : (
                        <>
                            <span>
                                <b>Тип:</b> {getClassTypeName(item, lesson)}
                            </span>
                            <span>
                                <b>Преподаватель:</b> {formatTeacherFromItem(item, lesson)}
                            </span>
                            <span>
                                <b>Группа:</b> {groupsDisplayName}
                            </span>
                            <span>
                                <b>Кабинет:</b> {getRoomName(item, lesson)}
                            </span>
                        </>
                    )}
                </LessonMeta>
            </LessonMain>

            <InlineActions>
                <DeleteButton
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation()
                        onDelete(classId)
                    }}
                >
                    Удалить
                </DeleteButton>
            </InlineActions>
        </LessonCard>
    )
}

export default EditScheduleLessonCard
